// extracted by mini-css-extract-plugin
export default {"uMbMi":"u-mb-mi___jjH3f","uMbXt":"u-mb-xt___coCcN","uMbT":"u-mb-t___TBmQ2","uMbS":"u-mb-s___jU34H","uMbM":"u-mb-m___WVgsI","uMbL":"u-mb-l___wII4J","uMbXl":"u-mb-xl___UZ7yB","uVisible":"u-visible___bU6mQ","uHidden":"u-hidden___z2KeU","uHiddenVisually":"u-hidden-visually___uDca0","isVh":"is-vh___y5b0w","uAlignLeft":"u-align-left___Usjna","uAlignRight":"u-align-right___Ky6QK","uAlignCenter":"u-align-center___gBX24","uRelative":"u-relative___t5Ijc","desktop":"desktop___drXin","mobile":"mobile___SXuKy","fadeIn":"fadeIn___hiSIc"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"uMbMi\":\"u-mb-mi___jjH3f\",\"uMbXt\":\"u-mb-xt___coCcN\",\"uMbT\":\"u-mb-t___TBmQ2\",\"uMbS\":\"u-mb-s___jU34H\",\"uMbM\":\"u-mb-m___WVgsI\",\"uMbL\":\"u-mb-l___wII4J\",\"uMbXl\":\"u-mb-xl___UZ7yB\",\"uVisible\":\"u-visible___bU6mQ\",\"uHidden\":\"u-hidden___z2KeU\",\"uHiddenVisually\":\"u-hidden-visually___uDca0\",\"isVh\":\"is-vh___y5b0w\",\"uAlignLeft\":\"u-align-left___Usjna\",\"uAlignRight\":\"u-align-right___Ky6QK\",\"uAlignCenter\":\"u-align-center___gBX24\",\"uRelative\":\"u-relative___t5Ijc\",\"desktop\":\"desktop___drXin\",\"mobile\":\"mobile___SXuKy\",\"fadeIn\":\"fadeIn___hiSIc\"}";
        // 1793018526487
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  